import clsx from "clsx";
import { t } from "i18next";
import { FC } from "react";

const cardHolderClasses = clsx(
  "grid grid-rows-1",
  "text-center",
  "flip-front",
  "h-full",
  "bg-slate-50",
  "p-0.5 md:p-2.5 rounded",
  "cursor-pointer",
  "drop-shadow"
);

const Card: FC<ISpreadCard> = ({ card, orientation }) => {
  return (
    <>
      <div className={cardHolderClasses}>
        <div className="row-start-1 row-end-1 col-start-1 col-end-1">
          <img
            className={clsx(
              "object-scale-down",
              "mx-auto",
              "h-full max-w-full",
              "max-h-[18rem] sm:max-h-[27rem]",
              "border border-slate-500 rounded",
              orientation.reversed ? "rotate-180" : "trackInpsect"
            )}
            src={card.image}
            alt={card.name}
          />
        </div>

        <div className="hidden md:grid text-center row-start-1 row-end-1 col-start-1 col-end-1 items-end z-10">
          <div className="bg-white/90 py-1.5 text-3xl font-yiddishkeit">
            <span dangerouslySetInnerHTML={{ __html: t(card.name) }} />
            &nbsp;
            {orientation.reversed && `(${t("Reversed")})`}
          </div>
        </div>
      </div>

      <div
        className={clsx(
          "absolute top-0 left-0 w-full h-full max-h-[29rem]",
          // "rotate-180 border-4 border-blue-600",
          // "shadow-[6px_6px_lightcoral]",
          "grid grid-rows-1 grid-cols-1 items-center justify-items-center",
          // "flex flex-col items-center justify-center",
          "bg-white",
          "flip-back",
          "p-0.5 sm:p-2",
          "drop-shadow-xl"
        )}
      >
        <div className="w-full h-full row-start-1 row-end-1 col-start-1 col-end-1 relative z-0 overflow-hidden bg-purple-300">
          <div className="rounded-full w-64 h-64 bg-pink-500 inline-block top-2 left-4 absolute blur-3xl z-10"></div>
          <div className="rounded-full w-64 h-64 bg-purple-500 inline-block bottom-1 right-4 absolute blur-3xl z-10"></div>
          <img
            className={clsx(
              "object-scale-down",
              "mx-auto",
              "relative z-0",
              "h-full max-w-full w-[24rem]",
              // "max-h-[18rem] sm:max-h-[29rem]",
              "border border-slate-500 rounded",
              "row-start-1 row-end-1 col-start-1 col-end-1 z-10",

              orientation.reversed ? "rotate-180" : "trackInpsect"
            )}
            src="https://storage.googleapis.com/tarot-svg/back_card.svg"
            alt=""
          />
        </div>
        <div className="row-start-1 row-end-1 col-start-1 col-end-1 w-1/2 z-20">
          <img
            src="https://storage.googleapis.com/tarot-svg/modern-tarot-logo.svg"
            className="opacity-80 mb-3"
            alt="Modern Tarot"
          />
          <div className="md:text-3xl text-white font-yiddishkeit">
            {t("Modern Tarot")}
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;
